import { ASSIGN_ACTION_NAME } from './constants';
import { MachineEvent } from './types';

type AssignAction<
  TContext,
  TEvent extends { type: string },
  TEventIn extends MachineEvent<TEvent> = MachineEvent<TEvent>,
> = (context: TContext, event: TEventIn) => Record<string, any>;

export function assign<
  TContext,
  TEvent extends { type: string },
  TEventIn extends MachineEvent<TEvent> = MachineEvent<TEvent>,
>(fn: AssignAction<TContext, TEvent, TEventIn>) {
  return (context: TContext, event: MachineEvent<TEvent>) => {
    return { type: ASSIGN_ACTION_NAME, data: fn(context, event as TEventIn) };
  };
}
